import styled from 'styled-components'

export const ExportButton = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-bottom: 0.5rem;
`
